import styled from "styled-components";
import { ActionComponent } from "../../shared/utils/userProfile";

export const AddProfileLink = styled(ActionComponent)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 20px 0;
  overflow: visible;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  max-width: ${theme.sizes.avatarSize};
  height: 267px;
  transition: transform 0.2s;
  color: ${theme.colours.white};
  background: transparent;
  border: 0;
  padding: 0;

  &:hover {
    transform: ${theme.scales.hoverEmphasis};
  }
`
);

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 180px;
  border: ${({ theme }) => "2px solid " + theme.colours.gray};
  border-radius: 50%;
  background-color: rgba(30, 30, 30, 0.8);
`;

export const AddProfileSpan = styled.span`
  margin-top: 16px;
  font: ${({ theme }) => theme.typography.primaryFont};
`;
